import IconComponent from "icons/IconComponent";

import FacebookIcon from "./facebook-icon.svg";

export default (FacebookIcon as any) as IconComponent;
